import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeepLinkTemplate } from 'components/Templates'

const DeepLink: FC = () => {
  return (
    <Layout
      headline={'sacriをお客さまに紹介する'}
      iconPath={'/icon/white/setting.svg'}
      title={'sacriをお客さまに紹介する'}
    >
      <DeepLinkTemplate />
    </Layout>
  )
}

export default DeepLink
